module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-back-top', {
    attrs: {
      "height": 500,
      "bottom": 86,
      "right": 45,
      "duration": 1000
    }
  }, [_c('mu-raised-button', {
    staticClass: "demo-raised-button mu-icon material-icons",
    attrs: {
      "label": "keyboard_arrow_up",
      "primary": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbacd86c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xtop.vue
// module id = 277
// module chunks = 0